import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ImportAnnotationsBl } from '../../../importAnnotations.bl';
import { IImportAnnotationsStore } from '../../../importAnnotations.store';
import { ImportAnnotationsStep } from '../../../models/ImportAnnotationsSteps';
import { ResolveConflictsStrategy } from '../../../models/ResolveConflictsStrategy';
import { HowToResolveConflictsStepModal } from './HowToResolveConflictsStepModal';

export const HowToResolveConflictsStepContainer = observer((): ReactElement => {
  const bl = useInjection(ImportAnnotationsBl.$);
  const store = useInjection(IImportAnnotationsStore.$);

  const handleHide = (): void => {
    bl.cancelImport();
  };

  const handleSubmit = async (): Promise<void> => {
    bl.resolveConflicts();

    if (store.resolveConflictsStrategy !== ResolveConflictsStrategy.Manually) {
      await bl.importAnnotationsAsync();
    }
  };

  const handleChangeStrategy = (strategy: ResolveConflictsStrategy): void => {
    bl.changeResolveConflictsStrategy(strategy);
  };

  const isCurrentStep = store.currentStep === ImportAnnotationsStep.HowToResolveConflicts;

  return (
    <HowToResolveConflictsStepModal
      onHide={handleHide}
      onSubmit={handleSubmit}
      show={isCurrentStep}
      resolveConflictsStrategy={store.resolveConflictsStrategy}
      onChangeStrategy={handleChangeStrategy}
      conflictsCount={store.conflicts.length}
    />
  );
});
